//export const publicKey = 'pk_test_nV12q3FJBvp7DXLMCyIGNAwe00A2t2tXc2'
export const publicKey = 'pk_live_0y6diCoplzPC9PvoO02OSLGA00DXn2GnK6'
